<template>
  <b-input
    type="textarea"
    :rows="rows || 5"
    :placeholder="placeholder"
    :value="asString"
    @blur="update"
    />
</template>

<script>
export default {
  emits: ['input'],
  props: {
    value: Array,
    rows: Number,
    placeholder: String,
  },
  computed: {
    asString () { return (this.value || []).join('\n') },
  },
  methods: {
    update (e) {
      const { value } = e.target
      const asList = (value || '').split('\n').map(v => v.trim()).filter(v => v !== '')
      this.$emit('input', asList)
    }
  }
}
</script>